import { useMutation } from "react-query"
import { changePassword } from "../api/changePassword"


export const useChangedPasword = (options) => {
    return useMutation(changePassword,options)
}